module.exports = __webpack_public_path__ + "img/time_split.caeda978.svg";